import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

type SimulateCart = components["schemas"]["SimulateCart"];

/**
 * POST /v1/promotions/{id}/simulate. The BE eval core is the single source of
 * rule semantics (no client-side rule engine — spec §7). A mutation (not a
 * query) because the caller drives it on demand from the synthetic-cart form.
 */
export function useSimulate(id: string) {
  return useMutation({
    mutationFn: async (cart: SimulateCart) => {
      const { data, error } = await apiClient.POST("/v1/promotions/{id}/simulate", {
        params: { path: { id } },
        body: { cart },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
  });
}
